export function CommingSoon({context}) {
    return (
        <div className="flexCol" style={{gap: '10px'}}>
            <h2 style={{marginBottom: "10px"}}>Comming soon!</h2>
        </div>
    )
}